import styled from "styled-components";
import { device } from "../breakpoints";

export const SliderWrapper = styled.div`
  overflow: hidden;
  max-width: 1200px;
  padding: 10px 0 10px 10px;
  position: relative;
  &::after {
    width: 10px;
    height: 100%;
    content: "";
    background-color: #fff;
    position: absolute;
    top: 0;
    right: 0;
  }
  @media ${device.mobile} {
    max-width: 100%;
    padding: 0;
    &::after {
      display: none;
    }
  }
`;
export const SpotlightCardItem = styled.div`
  width: 50%;
  flex-shrink: 0;
  @media ${device.mobile} {
    width: 100%;
    padding: 6px;
  }
`;
export const SliderHolder = styled.div`
  transition: ease 1000ms;
  display: flex;
`;
export const SlideDots = styled.div`
  text-align: center;
  margin-top: 35px;
  .slideshowDot {
    background: #3f3d56;
    opacity: 0.2;
    width: 12px;
    height: 12px;
    border-radius: 100%;
    display: inline-block;
    margin-right: 16px;
    cursor: pointer;
    transition: all 0.3s linear;
  }
  .slideshowDot.active {
    width: 32px;
    height: 12px;
    background: #000000 !important;
    opacity: 1;
    border-radius: 6px;
  }
  @media ${device.mobile} {
    margin-top: 20px;
    .slideshowDot {
      width: 8px;
      height: 8px;
      margin-right: 8px;
    }
    .slideshowDot.active {
      width: 20px;
      height: 8px;
    }
  }
`;
